module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "color": "#048019"
    }
  }, [_vm._v("Análise da Proposta")])], 1), (_vm.analise.ds_codigo_projeto_erp) ? _c('span', {
    staticStyle: {
      "color": "#a8a8a8"
    }
  }, [_vm._v(" -  N°Projeto: "), _c('b', [_vm._v(_vm._s(_vm.analise.ds_codigo_projeto_erp))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.ehSimplificada) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n      Proposta Simplificada\n    ")]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.bloqueia === true
    }
  }, [(_vm._.isNull(_vm.analise.fep) || _vm._.isUndefined(_vm.analise.fep) || _vm._.isEmpty(_vm.analise.fep) || _vm.analise.fep === '') ? _c('div', [_c('span', {
    staticClass: "mensagem naoPreenchido"
  }, [_vm._v("FEP ainda não gerada no sistema. É necessário informar o número da FEP")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numeroFepInformado),
      expression: "numeroFepInformado"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Qual vai ser o número da FEP?",
      "min": "0",
      "max": "999",
      "step": "1"
    },
    domProps: {
      "value": (_vm.numeroFepInformado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numeroFepInformado = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.resultadoVerificacaoFepExistente))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "disabled": _vm._.isNull(_vm.numeroFepInformado) || _vm._.isEmpty(_vm.numeroFepInformado) || (+_vm.numeroFepInformado < 1 || +_vm.numeroFepInformado > 999),
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.criaNovaFep(_vm.numeroFepInformado)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Gerar FEP")])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'proposta-visualiza' || _vm.analise.ds_fase !== 'ANALISE'
    }
  }, [(!_vm._.isNull(_vm.analise) && !_vm._.isEmpty(_vm.analise)) ? _c('fep', {
    attrs: {
      "propsAnalise": _vm.propsAnalise
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('fieldset', [_c('odsMarcacao', {
    attrs: {
      "proposta": _vm.analise.id,
      "telaProjeto": false
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.bloqueia === true
    }
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('legend', {
    attrs: {
      "disabled": false
    }
  }, [(_vm.analise.ds_fase === 'ANALISE') ? _c('fieldset', [_c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'relatorio-analise',
        params: {
          id: _vm.analise.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Preencher Relatório")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-success btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'visualiza-relatorio-analise',
        params: {
          id: _vm.analise.id,
          projeto: _vm.analise.ds_codigo_projeto_erp
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Visualizar Relatório")])], 1) : _c('fieldset', [_c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'relatorio-analise',
        params: {
          id: _vm.analise.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Visualizar Relatório")])], 1)])]), _vm._v(" "), (_vm._.isNull(_vm.analise.relatorio_analise)) ? _c('span', {
    staticClass: "mensagem naoPreenchido"
  }, [_vm._v(" Relatório da Análise não preenchido ainda")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.showModal) ? _c('div', {
    attrs: {
      "id": "modal4"
    }
  }, [_c('transition', {
    attrs: {
      "name": "modal",
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "id": "modal3"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper",
    attrs: {
      "id": "modal1"
    },
    on: {
      "click": function($event) {
        return _vm.$emit(_vm.showModal = true)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "id": "modal2"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Relatório da Análise")])]), _vm._v(" "), _c('relatorio-analise', {
    attrs: {
      "propsProposta": _vm.analise
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('b-button', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    attrs: {
      "type": "button",
      "disabled": false
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Salvar ")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-warning btn-sm btn-flat",
    attrs: {
      "type": "button",
      "disabled": false
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Fechar ")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('br')])], 1)])])])])], 1) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.ehSimplificada) ? _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: " with-border"
  }, [_vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.analise.ds_fase === 'ANALISE') ? _c('fieldset', [(!_vm.ehSimplificada) ? _c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'relatorio-rating',
        params: {
          id: _vm.analise.id
        },
        query: {
          entidade: _vm.analise.entidade.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" Calcular o Rating da Entidade")]) : _vm._e()], 1) : _c('fieldset', [(!_vm.ehSimplificada) ? _c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'relatorio-rating',
        params: {
          id: _vm.analise.id
        },
        query: {
          entidade: _vm.analise.entidade.id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Visualizar o Rating da Entidade")]) : _vm._e()], 1)]), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.analise.ds_fase !== 'CADASTRO') ? _c('questionario-riscos', {
    key: _vm.questRiscKey,
    ref: "child",
    attrs: {
      "disabled": this.$router.currentRoute.name === 'proposta-visualiza' || _vm.analise.ds_fase !== 'ANALISE',
      "propsAnalise": _vm.propsAnalise,
      "ehSimplificada": _vm.ehSimplificada
    },
    on: {
      "questionario": function($event) {
        _vm.analise.questionario_respostas = (Array.isArray($event) && $event.length === 0) ? {} : $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.analise) ? _c('categorizadores', {
    attrs: {
      "propsAnalise": _vm.propsAnalise,
      "indicativoAvaliacao": _vm.indicativoAvaliacao,
      "ehSimplificada": _vm.ehSimplificada
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.ehSimplificada) ? _c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'proposta-visualiza' || _vm.analise.ds_fase !== 'ANALISE'
    }
  }, [_c('questoesAvaliacaoProjeto', {
    ref: "questoesAvaliacao",
    attrs: {
      "idProposta": _vm.analise.id,
      "resultadoAprovacao": _vm.propsAnalise.resultadoAprovacao,
      "proximaEtapa": _vm.propsAnalise.proximaEtapa
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'proposta-visualiza' || _vm.analise.ds_fase !== 'ANALISE'
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "disabled": _vm.bloqueia === true
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('elementos característicos')
    },
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Elementos característicos")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "elementos característicos",
      "data-vv-as": "Elementos Característicos"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.analise.ds_caracteristicas_formalizacao),
      callback: function($$v) {
        _vm.$set(_vm.analise, "ds_caracteristicas_formalizacao", $$v)
      },
      expression: "analise.ds_caracteristicas_formalizacao"
    }
  }), _vm._v(" "), (_vm.errors.first('elementos característicos')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('elementos característicos')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "disabled": _vm.bloqueia === true
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('indicadores')
    },
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "indicadores"
    }
  }, [_vm._v("Indicadores de Resultado")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "placeholder": "Informe os indicadores de resultado",
      "data-vv-as": "Indicadores",
      "name": "indicadores"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.analise.ds_indicadores_resultado),
      callback: function($$v) {
        _vm.$set(_vm.analise, "ds_indicadores_resultado", $$v)
      },
      expression: "analise.ds_indicadores_resultado"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('indicadores')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('indicadores')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "disabled": _vm.bloqueia === true
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('acoes')
    },
    staticStyle: {
      "margin-left": "0px",
      "margin-right": "0px"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "acoes"
    }
  }, [_vm._v("Ações de Comunicação")]), _vm._v(" "), _c('div', [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "placeholder": "Informe as acões de comunicação",
      "data-vv-as": "Ações",
      "name": "acoes"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.analise.ds_acoes_comunicacao),
      callback: function($$v) {
        _vm.$set(_vm.analise, "ds_acoes_comunicacao", $$v)
      },
      expression: "analise.ds_acoes_comunicacao"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('acoes')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('acoes')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.bloqueia === true
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required",
    class: {
      'has-error': _vm.errors.first('periodicidade')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Periodicidade da apresentação dos relatórios de execução")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.ds_periodicidade_formulario),
      expression: "analise.ds_periodicidade_formulario"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "periodicidade",
      "aria-hidden": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.analise, "ds_periodicidade_formulario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.reportPeriodicity), function(i) {
    return _c('option', {
      domProps: {
        "value": i.id
      }
    }, [_vm._v(_vm._s(i.name))])
  }), 0), _vm._v(" "), (_vm.errors.first('periodicidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodicidade')))]) : _vm._e()])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.bloqueia === true
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-3 required-field",
    class: {
      'has-error': _vm.errors.first('data CMJ')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data do CMJ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(this.$router.currentRoute.name === 'projeto') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.dt_data_cmj),
      expression: "analise.dt_data_cmj"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|dateeqpast'),
      expression: "'required|dateeqpast'"
    }],
    ref: "dataCMJ",
    staticClass: "form-control ",
    attrs: {
      "type": "date",
      "name": "data do CMJ",
      "data-vv-as": "data do CMJ"
    },
    domProps: {
      "value": (_vm.analise.dt_data_cmj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.analise, "dt_data_cmj", $event.target.value)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.dt_data_cmj),
      expression: "analise.dt_data_cmj"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|dateeqpast|date_format:dd/MM/yyyy'),
      expression: "'required|dateeqpast|date_format:dd/MM/yyyy'"
    }],
    ref: "dataCMJ",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "data do CMJ",
      "placeholder": "__ /__ /____",
      "data-vv-as": "data do CMJ"
    },
    domProps: {
      "value": (_vm.analise.dt_data_cmj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.analise, "dt_data_cmj", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('data do CMJ')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data do CMJ')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3 required-field",
    class: {
      'has-error': _vm.errors.first('cmj')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número do CMJ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.ds_cmj),
      expression: "analise.ds_cmj"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cmj",
      "type": "text",
      "maxlength": "255",
      "placeholder": "Número do CMJ"
    },
    domProps: {
      "value": (_vm.analise.ds_cmj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.analise, "ds_cmj", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('cmj')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cmj')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3 required-field",
    class: {
      'has-error': _vm.errors.first('data parecer')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data do parecer jurídico")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(this.$router.currentRoute.name === 'projeto') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.dt_data_parecer_juridico),
      expression: "analise.dt_data_parecer_juridico"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|dateeqpast'),
      expression: "'required|dateeqpast'"
    }],
    ref: "dataParecerJuridico",
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "data do parecer juridico",
      "data-vv-as": "data do parecer juridico"
    },
    domProps: {
      "value": (_vm.analise.dt_data_parecer_juridico)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.analise, "dt_data_parecer_juridico", $event.target.value)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.dt_data_parecer_juridico),
      expression: "analise.dt_data_parecer_juridico"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|dateeqpast|date_format:dd/MM/yyyy|after:dataCMJ'),
      expression: "'required|dateeqpast|date_format:dd/MM/yyyy|after:dataCMJ'"
    }],
    ref: "dataParecerJuridico",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "data do parecer juridico",
      "placeholder": "__ /__ /____",
      "data-vv-as": "data do parecer juridico"
    },
    domProps: {
      "value": (_vm.analise.dt_data_parecer_juridico)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.analise, "dt_data_parecer_juridico", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('data do parecer juridico')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data do parecer juridico')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3 required-field",
    class: {
      'has-error': _vm.errors.first('número do parecer jurídico')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número do parecer jurídico")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.ds_parecer_juridico),
      expression: "analise.ds_parecer_juridico"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "número do parecer jurídico",
      "type": "text",
      "placeholder": "Número do parecer jurídico"
    },
    domProps: {
      "value": (_vm.analise.ds_parecer_juridico)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.analise, "ds_parecer_juridico", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('número do parecer jurídico')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('número do parecer jurídico')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  })]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.bloqueia === true
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.documentosAnalise,
      "propsEtapa": _vm.analise.ds_fase,
      "documentTypes": _vm.dctos,
      "documentosObrigatorios": '',
      "local-uso": 'TODOS'
    }
  })], 1)])]), _vm._v(" "), (_vm.analise.ds_fase === 'ANALISE') ? _c('fieldset', {
    attrs: {
      "disabled": _vm.bloqueia === true
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.first('resultadoAprovacao')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Decisões")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.resultadoAprovacao),
      expression: "analise.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "ENCAMINHAR_DEFERIMENTO"
    },
    domProps: {
      "checked": _vm._q(_vm.analise.resultadoAprovacao, "ENCAMINHAR_DEFERIMENTO")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.analise, "resultadoAprovacao", "ENCAMINHAR_DEFERIMENTO")
      }, function($event) {
        return _vm.limparInfo()
      }]
    }
  }), _vm._v(" Encaminhar para deferimento\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.resultadoAprovacao),
      expression: "analise.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "DEVOLVER_ENTIDADE"
    },
    domProps: {
      "checked": _vm._q(_vm.analise.resultadoAprovacao, "DEVOLVER_ENTIDADE")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.analise, "resultadoAprovacao", "DEVOLVER_ENTIDADE")
      }
    }
  }), _vm._v(" Devolver à entidade para ajustes\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.resultadoAprovacao),
      expression: "analise.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "INCLUIR_SAPIENS"
    },
    domProps: {
      "checked": _vm._q(_vm.analise.resultadoAprovacao, "INCLUIR_SAPIENS")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.analise, "resultadoAprovacao", "INCLUIR_SAPIENS")
      }
    }
  }), _vm._v(" Criar projeto e retornar para análise\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.resultadoAprovacao),
      expression: "analise.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "ENVIAR_PENDENCIAS"
    },
    domProps: {
      "checked": _vm._q(_vm.analise.resultadoAprovacao, "ENVIAR_PENDENCIAS")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.analise, "resultadoAprovacao", "ENVIAR_PENDENCIAS")
      }
    }
  }), _vm._v(" Enviar para pendências\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.resultadoAprovacao),
      expression: "analise.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "ANULAR_PROPOSTA"
    },
    domProps: {
      "checked": _vm._q(_vm.analise.resultadoAprovacao, "ANULAR_PROPOSTA")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.analise, "resultadoAprovacao", "ANULAR_PROPOSTA")
      }
    }
  }), _vm._v(" Anular proposta\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])]), _vm._v(" "), (_vm.errors.first('resultadoAprovacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('É necessário preencher uma decisão da Análise!')))]) : _vm._e(), _vm._v(" "), (_vm.analise.resultadoAprovacao === 'ENVIAR_PENDENCIAS') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Motivo da pendência")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "justificativa"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.analise.observacao),
      callback: function($$v) {
        _vm.$set(_vm.analise, "observacao", $$v)
      },
      expression: "analise.observacao"
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.analise.resultadoAprovacao === 'DEVOLVER_ENTIDADE') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Motivo da pendência")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "justificativa"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.analise.observacao),
      callback: function($$v) {
        _vm.$set(_vm.analise, "observacao", $$v)
      },
      expression: "analise.observacao"
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.analise.resultadoAprovacao === 'ANULAR_PROPOSTA') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Justificativa para reprovação")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "justificativa"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.analise.observacao),
      callback: function($$v) {
        _vm.$set(_vm.analise, "observacao", $$v)
      },
      expression: "analise.observacao"
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()], 1)]) : _vm._e()])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#fcfcfc"
    }
  }, [_c('legend', [_vm._v(" Relatório da Análise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-horizontal",
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('legend', {
    staticClass: "box-title"
  }, [_vm._v(" Rating da Entidade")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('legend', [_vm._v(" Periodicidade da apresentação dos relatórios de execução")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('legend', [_vm._v(" Parecer jurídico")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('legend', [_vm._v(" Documentos da Análise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('legend', [_vm._v(" Decisões da análise da proposta")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f9bdac5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/proposta/analise.vue
// module id = 1869
// module chunks = 2